import styled from 'styled-components'
import { GridLoader } from "react-spinners";

export default function LoadingAction() {
  return (
    <>
      <Loading>
        <GridLoader
          color="#ffffff"
          margin={10}
          size={30}
        />
      </Loading>

      <Dimmed/>
    </>
  )
}

const Loading = styled.div`
  z-index: 4;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Dimmed = styled.div`
  z-index: 3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
`;